module.exports = __webpack_public_path__ + "img/image14.e478f78b.png";